module.exports = "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\"><circle cx=\"17.82\" cy=\"18.11\" r=\"16.21\"/><path d=\"M29.28 29.57L48.21 48.5\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/search.svg
// module id = 540
// module chunks = 0